const baseUrl =
  'https://srv190-apigateway.tehran.ir/ApiContainer.CitizenAccountFront.RCL1/'
const baseCitizenTrafficUrl = 'https://srv190-apigateway.tehran.ir/ApiContainer.CitizenTraffic.Front.RCL1/';
const shahrzadUrl = import.meta.env.VITE_BASE_URL
const favaUrl = 'https://srv190-apigateway.tehran.ir/'
const walletUrl = favaUrl + 'ApiContainer.PelicanWallet.Front.RCL1/'
const authFava = favaUrl + 'ApiContainer.CitizenProfile.Front.RCL1/'

export const urls = {
  REFRESH_TOKEN: authFava + 'api/v1/Account/refresh-token',

  //Vehicle
  VEHICLE_LIST: baseUrl + 'api-frontend/Vehicle',
  CAR_DETAIL: baseUrl + 'api-frontend/Vehicle/detail/',
  SUBMIT_VEHICLE: baseCitizenTrafficUrl + 'api/v1/Vehicle/add',
  PLATE_ALPHABET: baseUrl + 'api-frontend/Vehicle/Letters',
  DELETE_CAR: baseUrl + 'api-frontend/Vehicle',
  PLAN_RESERVATION:
    baseUrl + 'api-frontend/TrafficPlanBooking/:plateNo/calendar',
  GET_BALANCE: walletUrl + 'api-frontend/v1/wallet/Balance',
  WALLET_TRANSACTIONS: walletUrl + 'api-frontend/v2/Transaction',

  //Shahrzad
  BANNERS: shahrzadUrl + 'base/api/v2/banners?platform=pwa',
  APP_TILES_NESTED:
    shahrzadUrl + 'base/api/v2/main-page/apps-nested?platform=pwa',
  USER_TOTAL_POINTS: shahrzadUrl + 'club/api/v1/user-total-points',

  // login
  LOGIN_OR_REGISTER: authFava + 'api/v1/Account/individual/login-or-register',
  LOGIN: authFava + 'api/v1/Account/login',

  // upgrade level
  REGISTER_VERIFY: authFava + 'api/v1/Account/individual/register/verify',
  UPGRADE_USER_LEVEL: authFava + 'api/v1/Account/individual/upgrade-to-level-2',
  VERIFY_REGISTER_LEVEL2:
    authFava + 'api/v1/Account/individual/upgrade-to-level-2/verify',

  //Debt
  TRAFFIC_RECORDS: baseUrl + 'api-frontend/TrafficPlan/:plateNo',
  DEBT_PAY: baseUrl + 'api-frontend/TrafficPlan/:plateNo/:billId/pay',

  //fava
  DECODE_TOKEN: favaUrl + 'apicontainer.sso.rcl1/connect/userinfo',

  // wallet
  CASH_OUT:
    favaUrl +
    'ApiContainer.PelicanWallet.Front.RCL1/api-frontend/v1/wallet/Cashout',
  TERMINALS:
    favaUrl +
    'ApiContainer.PelicanWallet.Front.RCL1/api-frontend/v1/wallet/Terminal',
  USER_CAMPAIGN:
    favaUrl +
    'ApiContainer.PelicanWallet.Front.RCL1/api-frontend/v1/wallet/Campaign/User/Terminal/:terminalId/:amount',

  //payment
  INCREASE_AMOUNT: shahrzadUrl + 'payment/api/v2/wallet/increase',

  CAMPAIGN:
    favaUrl +
    'ApiContainer.PelicanWallet.Front.RCL1/api-frontend/v1/wallet/Campaign',
  APP_TILES: shahrzadUrl + 'base/api/v2/main-page/apps?platform=pwa',

  // push notification
  PUSH_NOTIFICATION_VERIFY_ACCOUNT:
    shahrzadUrl + 'notification/api/v1/subscribers/add',
  PUSH_NOTIFICATION_UNVERIFY_ACCOUNT:
    shahrzadUrl + 'notification/api/v1/subscribers/add/unverified-device',
  CANCEL_SUBSCRIPTION:
    shahrzadUrl + 'notification/api/v1/subscribers/cancel-subscription',

  //club
  USER_ACTIVITY: shahrzadUrl + 'club/api/v1/user-activity',

  //referral

  REFER_CODE:
    favaUrl + 'ApiContainer.CitizenProfile.Front.RCL1/api/Profile/referer',

  //location
  GET_LOCATION:
    favaUrl + 'ApiContainer.GIS.RCL1/api/v1/getbypoints/GetCoverageAreaByPoint',
}
